import React, { useEffect } from 'react';

const AddCookieScriptToHead = () => {
  useEffect(() => {
    /**
     * Retrieves a cookie value by its name.
     * @param name - The name of the cookie.
     * @returns The cookie value if found, otherwise undefined.
     */
    const getCookie = (name) => {
      const cookieString = `; ${document.cookie}`;
      const parts = cookieString.split(`; ${name}=`);
      return parts.length === 2 ? parts[1].split(';')[0] : undefined;
    };

    // Retrieve the 'preferences' cookie
    const preferences = getCookie('preferences');

    // If 'preferences' cookie is not set, add the script to the document head
    if (!preferences) {
      const script = document.createElement('script');
      script.src = 'https://media.foundit.in/dpdpa-banners/dpdpa-script.js';
      script.async = true; // Load the script asynchronously
      document.head.appendChild(script);

      // Cleanup function to remove the script when the component unmounts
      return () => {
        document.head.removeChild(script);
      };
    }
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return null; // This component renders nothing
};

export default AddCookieScriptToHead;
